module.exports = __webpack_public_path__ + "img/tv.tv12b9353.svg";